import { render } from "./PacsSettingPopup.vue?vue&type=template&id=2d8cda41&scoped=true&ts=true"
import script from "./PacsSettingPopup.vue?vue&type=script&lang=ts"
export * from "./PacsSettingPopup.vue?vue&type=script&lang=ts"

import "./PacsSettingPopup.vue?vue&type=style&index=0&id=2d8cda41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8cda41"]])

export default __exports__